import { HStack, Select } from '@chakra-ui/react';

interface SortOption {
  value: string;
  label: string;
}

interface TableSortControlsProps {
  sortOptions: SortOption[];
  currentSortBy: string;
  currentSortOrder: 'asc' | 'desc';
  isLoading: boolean;
  onSortByChange: (value: string) => void;
  onSortOrderChange: (value: 'asc' | 'desc') => void;
  limitOptions?: number[];
  currentLimit?: number;
  onLimitChange?: (value: number) => void;
}

export const TableSortControls = ({
  sortOptions,
  currentSortBy,
  currentSortOrder,
  isLoading,
  onSortByChange,
  onSortOrderChange,
  limitOptions = [10, 50, 100, 250, 500],
  currentLimit,
  onLimitChange,
}: TableSortControlsProps) => {
  return (
    <HStack spacing={4}>
      {onLimitChange && currentLimit && (
        <Select
          onChange={(e) => onLimitChange(Number(e.target.value))}
          value={currentLimit}
          isDisabled={isLoading}
          minW={{ base: '80px', md: '120px' }}
          aria-label="Items per page"
        >
          <option disabled value="">
            Page Size
          </option>
          {limitOptions.map((limit) => (
            <option key={limit} value={limit}>
              {limit}
            </option>
          ))}
        </Select>
      )}

      <Select
        onChange={(e) => onSortByChange(e.target.value)}
        value={currentSortBy}
        isDisabled={isLoading}
        minW={{ base: '80px', md: '120px' }}
        aria-label="Items sort by"
      >
        <option disabled value="">
          Sort By
        </option>
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>

      <Select
        onChange={(e) => onSortOrderChange(e.target.value as 'asc' | 'desc')}
        value={currentSortOrder}
        isDisabled={isLoading}
        minW={{ base: '80px', md: '120px' }}
        aria-label="Items sort order"
      >
        <option disabled value="">
          Sort Order
        </option>
        <option value="asc">ASC</option>
        <option value="desc">DESC</option>
      </Select>
    </HStack>
  );
};
